import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const CandidateProfile = () => {
  const { t } = useTranslation();
  const userName = useSelector((state) => state.user.userData.firstName);
  const formFirstName = useSelector((state) => state.form.userData.firstName);
  const splittedName = formFirstName
    ? formFirstName?.split(" ")
    : userName?.split(" ");
  const firstLetterUserName = splittedName[0]?.slice(0, 1);
  const lastLetterUserName = splittedName[1]?.slice(0, 1) || "";
  const upperCaseInitials =
    `${firstLetterUserName}${lastLetterUserName}`.toUpperCase();

  return (
    <>
      <div className="condidate-profile row">
        <div className="condidate-profile-div d-flex align-items-center w-auto p-0">
          <div className="condidate-img-avatar d-flex align-items-center justify-content-center">
            {upperCaseInitials}
          </div>
          <div className="condidate-name">
            <span>{formFirstName || userName}</span>
            <p className="mb-0" style={{fontSize: "12px"}}>{t("dashboard.headTitle")}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default CandidateProfile;
